import { X } from 'lucide-react';
const Modal = ({ title, subtitle, children, onClose, wide }) => (
  <div className="fixed inset-0 z-[100]">
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm animate-fade-in" onClick={onClose} />
    <div className="fixed inset-0 flex items-center justify-center p-4">
      <div className={`bg-white rounded-2xl shadow-xl max-h-[90vh] overflow-hidden flex flex-col animate-scale-in relative ${wide ? 'w-full max-w-4xl' : 'w-full max-w-lg'}`}>
        <div className="px-5 py-4 border-b border-pw-border-variant flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold text-pw-text">{title}</h2>
            {subtitle && <p className="text-pw-text-variant text-sm mt-0.5">{subtitle}</p>}
          </div>
          <button onClick={onClose} className="p-2 hover:bg-pw-surface rounded-xl transition-colors">
            <X className="w-5 h-5 text-pw-muted" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto flex-1 custom-scrollbar">{children}</div>
      </div>
    </div>
  </div>
);
export default Modal;
